<div class="container">
  <div class="row m-0">
    @for (file of files(); track file) {
      <div class="col-lg-4 col-md-6 mb-2">
        <div class="border rounded bg-syk-grey p-1">
          <div class="row align-items-center m-0">
            <div class="col px-1 text-truncate">
              {{file.file.name}}
            </div>
            <div class="col-auto">
              {{file.file.size | filesize}}
            </div>
          </div>
          <div class="row align-items-center m-0">
            <div class="progress p-0" role="progressbar" aria-valuemin="0" [attr.aria-valuenow]="getProgressValue(file)" aria-valuemax="100" aria-label="progress bar">
              <div class="progress-bar text-bg-{{getProgressType(file)}}"
                [class.progress-bar-animated]="isIndeterminateProgress(file)"
                [class.progress-bar-striped]="isIndeterminateProgress(file)"
                [style.width.%]="getProgressValue(file)">
                @if (showProgressValue(file)) {
                  <span>{{ getProgressValue(file) / 100 | percent }}</span>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
</div>
